import styled from '@emotion/styled';

export const FormLabel = styled.label<{ bold?: boolean }>(
  ({ bold, theme }) => ({
    color: theme.color.textPrimary,
    fontSize: theme.fontSize.md,
    fontWeight: bold ? 'bold' : undefined,
  }),
);
